import { motion } from "framer-motion";
import { BadgeCheck, CalendarCheck2, Code2, Cpu, Gauge, HeartHandshake, MonitorSmartphone, PenTool, Puzzle, ShieldCheck, Smartphone, Target } from "lucide-react";
import { SectionHeading } from "./Reveal";
import { EASE } from "@/lib/site";

const ITEMS = [
  { icon: Code2, t: "Desenvolvimento personalizado", d: "Cada projeto é construído do zero para o seu objetivo." },
  { icon: PenTool, t: "Design profissional", d: "Visual moderno que valoriza a sua marca." },
  { icon: Cpu, t: "Tecnologia moderna", d: "Ferramentas atuais, estáveis e escaláveis." },
  { icon: MonitorSmartphone, t: "Responsividade", d: "Perfeito em celulares, tablets e computadores." },
  { icon: Smartphone, t: "Experiência mobile", d: "Pensado primeiro para quem navega pelo celular." },
  { icon: Gauge, t: "Performance", d: "Carregamento rápido para não perder clientes." },
  { icon: ShieldCheck, t: "Segurança", d: "Boas práticas para proteger seu projeto e seus dados." },
  { icon: Puzzle, t: "Soluções sob medida", d: "Funcionalidades criadas para a sua necessidade." },
  { icon: HeartHandshake, t: "Atendimento próximo", d: "Comunicação clara do início ao fim." },
  { icon: Target, t: "Foco no seu negócio", d: "Tecnologia a serviço dos seus resultados." },
  { icon: CalendarCheck2, t: "Experiência desde 2020", d: "Criando soluções digitais desde 2020." },
  { icon: BadgeCheck, t: "Compromisso com qualidade", d: "Atenção aos detalhes em cada entrega." },
];

export const Differentials = () => (
  <section data-testid="differentials-section" className="relative overflow-hidden bg-ws-panel py-24 sm:py-32">
    <div className="line-grid mask-radial pointer-events-none absolute inset-0 opacity-60" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHeading index="06" eyebrow="Diferenciais" title="Por que escolher a WebStation?" testid="differentials-title" />
      <div className="mt-16 grid grid-cols-1 gap-px overflow-hidden rounded-3xl border border-white/[0.07] bg-white/[0.07] sm:grid-cols-2 lg:grid-cols-4">
        {ITEMS.map((it, i) => (
          <motion.div
            key={it.t}
            data-testid={`differential-${i}`}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.7, delay: (i % 4) * 0.08, ease: EASE }}
            className="group relative bg-ws-panel p-7 transition-colors duration-500 hover:bg-ws-card"
          >
            <motion.span
              whileHover={{ rotate: 12, scale: 1.12 }}
              transition={{ type: "spring", stiffness: 300, damping: 12 }}
              className="relative grid h-12 w-12 place-items-center rounded-xl border border-ws-lime/20 bg-ws-bg text-ws-lime transition-[box-shadow] duration-300 group-hover:shadow-[0_0_28px_-4px_rgba(124,255,26,.7)]"
            >
              <it.icon size={21} className="icon-bob" style={{ animationDelay: `${i * 0.33}s` }} />
            </motion.span>
            <h3 className="mt-6 font-body text-base font-semibold text-ws-text">{it.t}</h3>
            <p className="mt-2 text-sm leading-relaxed text-ws-muted">{it.d}</p>
            <span className="absolute bottom-0 left-0 h-px w-0 bg-ws-lime transition-[width] duration-500 group-hover:w-full" />
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
